export const fetchHubSpotEnrichmentStart = (key) => {
    return {
      type: "FETCH_HUBSPOT_ENRICHMENT_STARTED",
      key
    }
  }
  
  export const fetchHubSpotEnrichmentFailed = (err, key) => {
    return {
      type: "FETCH_HUBSPOT_ENRICHMENT_FAILED",
      err,
      key
    }
  }
  
  export const fetchHubSpotEnrichmentSuccess = (data, key) => {
    return {
      type: "FETCH_HUBSPOT_ENRICHMENT_SUCCESS",
      data,
      key
    }
  }